import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { isMobile, isBrowser } from 'react-device-detect';

const AbroadPhonesInstructions = (props) => {
  const [androidCollapse, setAndroidCollapse] = useState(false);
  const [appleCollapse, setAppleCollapse] = useState(false);

  const toggleAndroidCollapse = () => {
    if (appleCollapse) {
      setAppleCollapse(false);
    }
    setAndroidCollapse(!androidCollapse);
  };

  const toggleAppleCollapse = () => {
    if (androidCollapse) {
      setAndroidCollapse(false);
    }
    setAppleCollapse(!appleCollapse);
  };

  return (
    <>
      {!androidCollapse && (
        <div onClick={() => toggleAndroidCollapse()} className='android-collapse-area-close'>
          <span>יש לי אנדרואיד</span>
          <Image src={require('./images/down-arrow.svg')} alt='light-icon' />
        </div>
      )}

      {androidCollapse && (
        <div className='android-collapse-area-open' onClick={() => toggleAndroidCollapse()}>
          <div className='top-collapse-android-open'>
            <span>יש לי אנדרואיד</span>
            <Image src={require('./images/up-arrow.svg')} alt='light-icon' />
          </div>
          <div>
            {!isMobile ? (
              <div>
                <span className='d-block text-right'>
                  הגדרות
                  <span className='sign'>
                    <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                  </span>
                  חיבורים
                  <span className='sign'>
                    {' '}
                    <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                  </span>
                  רשתות תקשורת סלולרית
                  <span className='sign'>
                    {' '}
                    <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                  </span>
                  להפעיל
                </span>
                <span className='d-block'>את הכפתור "נתונים בנדידה"</span>
              </div>
            ) : (
              <div>
                <span className='d-block text-right'>
                  הגדרות
                  <span className='sign'>
                    <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                  </span>
                  חיבורים
                  <span className='sign'>
                    {' '}
                    <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                  </span>
                  רשתות תקשורת
                  <span className='d-block' style={{ marginBottom: '-5px' }}>
                    סלולרית
                    <span className='sign'>
                      {' '}
                      <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                    </span>
                    להפעיל את כפתור
                  </span>
                </span>
                <span className='d-block'>"נתונים בנדידה"</span>
              </div>
            )}
          </div>
        </div>
      )}

      {!appleCollapse && (
        <div onClick={() => toggleAppleCollapse()} className='apple-collapse-area-close'>
          <span>יש לי IOS</span>
          <Image src={require('./images/down-arrow.svg')} alt='light-icon' />
        </div>
      )}
      {appleCollapse && (
        <div className='apple-collapse-area-open' onClick={() => toggleAppleCollapse()}>
          <div className='top-collapse-apple-open'>
            <span>יש לי IOS</span>
            <Image src={require('./images/up-arrow.svg')} alt='light-icon' />
          </div>
          {!isMobile ? (
            <div>
              <span className='d-block text-right'>
                הגדרות
                <span className='sign'>
                  {' '}
                  <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                </span>
                סלולרי
                <span className='sign'>
                  {' '}
                  <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                </span>
                אפשרויות נתונים סלולריים
                <span className='sign'>
                  {' '}
                  <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                </span>
                להפעיל
              </span>
              <span className='d-block'>את הכפתור "נתונים בנדידה"</span>
            </div>
          ) : (
            <div>
              <span className='d-block text-right'>
                הגדרות
                <span className='sign'>
                  <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                </span>
                סלולרי
                <span className='sign'>
                  {' '}
                  <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                </span>
                אפשרויות נתונים
                <span className='d-block' style={{ marginBottom: '-5px' }}>
                  סלולריים
                  <span className='sign'>
                    {' '}
                    <Image src={require('./images/icon-16-chevron-purple-left.svg')} alt='arrow-left' />
                  </span>
                  להפעיל את כפתור
                </span>
              </span>
              <span className='d-block'>"נתונים בנדידה"</span>
            </div>
          )}
        </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    selfCareSlice: state.selfcarePage,
    abroadSlice: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadPhonesInstructions);
